import ApplePayValidator from './ApplePayValidator';
import GooglePayValidator from './GooglePayValidator';
import { ReactElement } from 'react';

interface Props {
  children?: ReactElement;
}

export default function PaymentWalletsValidator({ children }: Props) {
  return (
    <>
      <ApplePayValidator>{children}</ApplePayValidator>
      <GooglePayValidator>{children}</GooglePayValidator>
    </>
  );
}
